import React from "react";
import { motion } from "framer-motion";
import { User, Dumbbell, Anchor, Footprints, PersonStanding, Timer, Scale, Gauge, Flame, Activity, Rows3, HeartPulse, ExternalLink } from "lucide-react";
import { useLang } from "../../i18n";
import { riderTraining, horseTraining } from "../../data/safety";

const icons = { Anchor, Footprints, Dumbbell, PersonStanding, Timer, Scale, Gauge, Flame, Activity, Rows3, HeartPulse };

function refUrl(ref) {
  if (!ref) return null;
  return /^\d+$/.test(ref) ? `https://pubmed.ncbi.nlm.nih.gov/${ref}/` : `https://doi.org/${ref}`;
}

function Section({ title, icon: Icon, data }) {
  const { lang } = useLang();
  return (
    <div>
      <div className="flex items-center gap-2.5">
        <span className="h-9 w-9 rounded-md bg-sonne/12 border border-sonne/30 flex items-center justify-center text-sonne"><Icon size={18} /></span>
        <h3 className="font-serif text-2xl">{title}</h3>
      </div>
      <p className="mt-3 text-sm text-wachs-dim leading-relaxed max-w-2xl">{lang === "de" ? data.introDe : data.introEn}</p>
      <div className="mt-5 grid gap-3 md:grid-cols-2">
        {data.blocks.map((b, i) => {
          const BIcon = icons[b.icon] || Activity;
          const url = refUrl(b.ref);
          const c = lang === "de" ? b.de : b.en;
          return (
            <motion.div
              key={c.t}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.04 }}
              className="grid-panel rounded-lg p-4 hover:border-sonne/40 transition-colors"
            >
              <div className="flex items-start gap-3">
                <BIcon size={18} className="text-bronze-soft shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-wachs">{c.t}</p>
                  <p className="mt-1 text-sm text-wachs-dim leading-relaxed">{c.d}</p>
                  {url && (
                    <a href={url} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center gap-1 font-mono text-[11px] text-sonne hover:underline">
                      {b.ref && /^\d+$/.test(b.ref) ? "PubMed" : "DOI"} <ExternalLink size={10} />
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}

export default function FitnessGuide() {
  const { t } = useLang();
  return (
    <div className="space-y-10">
      <p className="text-sm text-wachs-dim leading-relaxed max-w-2xl">{t.safety.fitness.intro}</p>
      <Section title={t.safety.fitness.riderTitle} icon={User} data={riderTraining} />
      <Section title={t.safety.fitness.horseTitle} icon={HeartPulse} data={horseTraining} />
    </div>
  );
}
